import createHistory from 'history/createBrowserHistory'

const history = createHistory()

const parentPath = path =>
  path
    .split('/')
    .slice(0, -1)
    .join('/')

export const toParentPath = () =>
  history.replace(parentPath(history.location.pathname))

export default history



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helpers/History.ts